import { create } from "axios";

import { getBackendUrl } from "../utils/getBackendUrl";

export const axiosInstance = create({
  baseURL: getBackendUrl(),
});
